import { Component, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { IProjectNote } from 'src/app/project-display/interfaces/IProjectNote';
import { ProjectNotesStoreService } from 'src/app/project-display/data-access/project-notes-store-service';

@Component({
  selector: 'eic-project-notes-list',
  templateUrl: './project-notes-list.html',
  styleUrl: './project-notes-list.scss'
})
export class ProjectNotesList {

  @Input() showMemberNoteControls: boolean;

  projectNotes$: Observable<IProjectNote[]>;

  constructor(public projectNotesStore: ProjectNotesStoreService) {
    this.projectNotes$ = this.projectNotesStore.filteredNotes
  }

  isMemberNote(projectNote: IProjectNote): boolean {
    return !!projectNote?.noteTypes?.some(n => n.noteTypeID == 6);
  }

  isAnalystOpinion(projectNote: IProjectNote): boolean {
    return !!projectNote?.noteTypes?.some(n => n.noteTypeID == 7);
  }

}
